// const mediaLimitMessageValueProp = 'Up to 25 videos or images at a time';
const noLimitsValueProp = 'No bandwidth limits';
const freeSupportValueProp = 'Free email and phone support';
const noCreditCardNecessary = 'No credit card required to start trial';

export enum activityTypeDescriptions {
   newComment = 'added a comment to',
   newCommentReply = 'replied to your comment on',
   newReviewConfirmation = 'You have successfully created a new review',
   newReviewInvitation = 'invited you to review',
   reviewByDateModification = 'changed the deadline on',
   deadlineApproaching = 'has a review approaching the deadline',
   startTrial = 'You have successfully started your trial',
   newReviewVersionConfirmation = 'You have successfully created new version for review',
   newReviewVersionInvitation = 'invited you to review a new version of'
}

export default Object.freeze({
   websiteTitleDefault: 'TechSmith | Video Review',
   errors: {
      failedUpdatePreference: 'Your notification preference was not saved. Please check your network connection and try again.',
      failedSaveComment: 'Oops, we weren\'t able to save your comment. Please check your network connection and try again.',
      failedDeleteComment: 'Oops, we weren\'t able to delete your comment. Please check your network connection and try again.',
      failedDeleteVersion: 'Oops, we weren\'t able to delete the version. Please check your network connection and try again.',
      failedDeleteReview: 'Oops, we weren\'t able to delete your review. Please check your network connection and try again.',
      failedSaveReviewByDate: 'Oops, we weren\'t able to save your deadline date. Please check your network connection and try again.',
      failedUpdateReview: 'Oops, we weren\'t able to update the review. Please check your network connection and try again.',
      failedLoadDashboard: 'We weren\'t able to load your dashboard. Please check your network connection and try again.',
      failedUploadMedia: 'Oops, we weren\'t able to upload your media. Please check your network connection and try again.',
      failedUpdateReviewsGroup: 'Oops, we weren\'t able to update your reviewers group. Please check your network connection and try again.',
      failedCreateReviewersGroup: 'Oops, we weren\'t able to create your reviewers group. Please check your network connection and try again.',
      cannotAccessReview: '{param0} Cannot Access this Review',
      cannotAccessReviewDetail: 'Make sure you are logged in with the correct account, or contact the review owner to request access.',
      noLongerReviewer: '{param0} Was Removed From this Review',
      noLongerReviewerDetail: 'Your access has been removed from this review. To request access, please contact the content owner.',
      noNetworkConnection: 'No Network Connection',
      serverError: 'Something Went Wrong',
      serverErrorDetail: 'An unexpected error has occurred. Please try refreshing the page. Or you can contact us if the problem persists.',
      serverErrorDetail1: 'An unexpected error has occurred. Please try refreshing the page. Or you can ',
      serverErrorDetail2: 'contact us',
      serverErrorDetail3: ' if the problem persists.',
      pageError: 'Page Not Found',
      pageErrorDetail: 'Sorry, we can\'t find that page. It might be an old link or maybe it moved.',
      noEmailAvailable: '(NO EMAIL AVAILABLE)',
      uploadCancelled: 'Upload was cancelled',
      userInfoChanged: 'Your session has expired, please refresh the page.',
      couldNotStartTrial: 'Oops, we weren\'t able to add you to the trial. Please check your network connection and try again.',
      failedToGetArchive: 'Oops, we weren\'t able to download your comments. Please check your network connection and try again.',
      failedUpdatingReviewers: 'Error attempting to update reviewers. Please try again later.',
      failedAddingReview: 'Error attempting to save new review. Please try again later.',
      failedAddingVersion: 'Error attempting to save new version. Please try again later.',
      failedSaveGroup: 'An error occurred, please try again.',
      invalidGroupEmails: 'Enter some reviewers to continue.',
      invalidGroupName: 'Enter a group name to continue.',
      invalidGroupNameLength: 'Group name cannot exceed {param0} characters.',
      groupNameExists: 'Group name already used. Pick a new one.',
      missingTitle: 'A title is required',
      invalidTitleLength: 'Titles cannot exceed {param0} characters',
      invalidPromptLength: 'Descriptions cannot exceed {param0} characters',
      invalidDisplayNameLength: 'Names cannot exceed {param0} characters',
      reviewDeleted: 'You no longer have access to this. Please refresh the page.',
      failedLeaveReview: 'Oops, we weren\'t able to remove you from this review. Please check your network connection and try again.'
   },
   defaults: {
      emptyComment: '(Comment deleted)',
      annotationAttached: '(Annotation attached)',
      deadlinePlaceholder: 'No Deadline Assigned',
      manageReviewersInput: 'Enter email addresses'
   },
   labels: {
      commentReplyThread: {
         show: 'Show',
         hide: 'Hide',
         reply: 'reply',
         replies: 'replies'
      },
      CamtasiaPreSignin: {
         header: 'TechSmith Video Review',
         text: 'Quickly get specific, actionable feedback from your peers and stakeholders on all your video projects.',
         signIn: 'Sign In',
         continue: 'Continue',
         cancel: 'Cancel',
         footerText1: 'TechSmith Video Review is an internet-based service.',
         footerText2: 'By continuing, you consent to our use of cookies.'
      },
      quizzing: {
         quizzingModeHeader: 'Playback Disabled',
         quizzingModeText: 'Complete the current quiz to continue.',
         setupModeText: 'Enter your info to continue.'
      },
      annotations: {
         square: 'Square Tool',
         arrow: 'Arrow Tool',
         freehand: 'Freehand Tool',
         colorPicker: 'Color Picker Tool',
         clear: 'Clear',
         annotationModeHeader: 'Annotation Mode',
         annotationModeText: 'Submit comment or clear drawing to exit mode.',
         hideAnnotation: 'Hide Annotation',
         showAnnotation: 'Show Annotation',
         removeAnnotation: 'Remove Annotation'
      },
      sortDirectionButton: {
         preText: 'Sort',
         date: {
            ascending: {
               label: 'Oldest First',
               title: 'Showing oldest reviews first'
            },
            descending: {
               label: 'Newest First',
               title: 'Showing newest reviews first'
            }
         },
         title: {
            ascending: {
               label: 'Title (A to Z)',
               title: 'Showing reviews by title, A to Z'
            },
            descending: {
               label: 'Title (Z to A)',
               title: 'Showing reviews by title, Z to A'
            }
         }
      },
      remainingReviewsLabelText: 'Displaying {numberOfReviews} of {totalReviewCount} Reviews',
      remainingReviewsButtonText: 'Load More Reviews',
      deadlineApproachBody: 'The deadline for reviewing {param0} is approaching. Deadline date - {param1}',
      reviewByDateChangeBody: 'The deadline for reviewing {param0} has been changed to - {param1}.',
      reviewInvitationBody: 'You have been invited to review {param0}.',
      reviewConfirmationBody: 'You have successfully created a new review {param0}.',
      reviewVersionConfirmationBody: 'You have successfully created {param0} - Version {param1}.',
      reviewVersionInvitationBody: 'You have been invited to review {param0} - Version {param1}.',
      help: 'Help',
      finishPurchaseHeader: 'Confirm Purchase',
      finishPurchaseBody: 'After you have purchased and received your order confirmation, click Continue to start sharing your videos to TechSmith Video Review.',
      finishPurchaseError: 'Purchase not complete. Make sure you received your order confirmation and try again.',
      continue: 'Continue',
      buyNow: 'Buy Now',
      owner: '{param0} (Owner)',
      additionalReviewers: '+ {param0} more',
      done: 'Done',
      backToHomeButton: 'Back to Home',
      likeButtonText: 'Like',
      unlikeButtonText: 'Unlike',
      likeComment: 'Like comment',
      unsavedEdit: 'Unsaved edit',
      useDarkTheme: 'Use Dark Theme',
      manageGroups: 'Manage User Groups',
      edit: 'Edit',
      editTitle: 'Edit Title',
      editDescription: 'Edit Description',
      editComment: 'Edit comment',
      editTitleAndDescriptionButtonTitle: 'Edit title and description',
      enterGroup: 'Enter Group Name',
      enterReviewers: 'Enter Reviewers',
      typeGroup: 'Type group name',
      emptyGroups: 'You have not created any groups yet.',
      managePreferences: 'Manage Preferences',
      termsOfService: 'Terms of Service',
      helpCenter: 'Help Center',
      reviewDeadlinePrefix: 'Review by:',
      addComment: 'Add a comment',
      addReviewerGroup: 'Add Reviewer Group',
      reply: 'Reply',
      replyToComment: 'Reply to comment',
      resolved: 'Resolved',
      viewGrid: 'Grid view',
      viewList: 'List view',
      search: 'Search',
      filter: 'Filter loaded reviews',
      startReview: 'Start Review',
      review: 'Review',
      createGroup: 'Create Group',
      updateGroup: 'Save Group',
      editGroup: 'Edit User Group',
      savingGroup: 'Saving Group',
      deleteGroup: 'Delete Group',
      deleteComment: 'Delete Comment',
      clearAnnotation: 'Clear Annotation',
      addNewGroup: 'Add New Group',
      groups: 'Groups',
      saveGroup: 'Save this group for later',
      buyButtonText: 'Buy Now',
      trialModalBannerSubText: 'Start Your Free Trial',
      startTrialHeader: 'Start Your Trial',
      trialSubText: 'Free for 30 Days',
      trialModalPrompt: 'Start Trial and Continue',
      trialModalShortenedPrompt: 'Start Trial',
      trialModalLearnMorePrompt: 'Learn More',
      datePickerToday: 'Today',
      trialExpiresInDays: 'Trial Expires in {param0} Days',
      trialExpiresToday: 'Trial Expires Today',
      trialExpired: 'Trial Expired',
      purchaseVideoReview: 'Purchase Video Review to continue getting feedback.',
      draw: 'Draw',
      submit: 'Submit',
      dashboard: 'Dashboard',
      media: 'Media',
      manageMedia: 'Manage Media',
      delete: 'Delete',
      edited: '(Edited)',
      emailReviewers: 'Email Reviewers',
      dontSendReviewers: 'Don\'t Send',
      close: 'Close',
      cancel: 'Cancel',
      remove: 'Remove',
      exportComments: 'Export Comments',
      save: 'Save',
      options: 'Options',
      deleteReview: 'Delete Review',
      leaveReview: 'Leave Review',
      leave: 'Leave',
      confirmLeaveText: 'This will remove you from all versions of this review.',
      removeReviewer: 'Remove reviewer',
      removeReviewerMessage: 'Changes will affect all versions of the review',
      cancelRemoveReviewer: 'Cancel removal of reviewer',
      deadlineChanged: 'Deadline Changed',
      confirmDeadlineChangedNotifications: 'Would you like to notify your reviewers?',
      confirmDeletionText: 'This will permanently delete the review and any comments associated with it.',
      confirmGroupDeletionText: 'This will permanently delete the group.',
      confirmCommentDeletionText: 'This will permanently delete the comment.',
      confirmCanvasDeletionText: 'This will delete all of your annotations from the canvas.',
      downloadReviewDataText: 'Download the comments data for your records.',
      downloadReviewDataButtonText: 'Download Review Data',
      downloadReviewDataButtonDisabledText: 'Downloading Data Now',
      createReview: 'Create Review',
      back: 'Back',
      date: 'Date',
      invite: 'Invite',
      add: 'Add',
      addReply: 'Add a reply',
      required: '*',
      addReviewersButtonText: 'Reviewers',
      addReviewersButtonTitle: 'Manage reviewers',
      noResultsFound: 'No results in loaded reviews',
      hideResolvedComments: 'Hide {param0} Resolved',
      showResolvedComments: 'Show {param0} Resolved',
      noResolvedComments: 'No resolved comments',
      searchComments: 'Search comments',
      noDescriptionProvided: 'No Description Provided',
      weSendEmails: 'We\'ll send a few emails to help you get started.',
      unsubscribe: 'Unsubscribe at any time.',
      receiveNotifications: 'Receive Notifications',
      selfIdentifiedCommentingAs: {
         cancel: 'Cancel',
         commentingAs: 'Commenting as {param0}.',
         changeReviewer: 'Change Reviewer',
         alertText: 'Are you sure you want to change the reviewer? You will no longer be able to add, edit, or delete comments as {param0}.'
      },
      share: 'Share',
      fileImporter: {
         selectUploadFile: 'Browse for File',
         dragAndDropUpload: 'Drag and Drop File',
         uploadInProgress: 'Uploading...'
      },
      buyNowModal: {
         bannerText: 'Purchase Video Review',
         prompt: 'Buy Now',
         price: '$180/year USD',
         bodyHeader: 'Your Trial Expired',
         bodyText: 'Please purchase a subscription to continue using TechSmith Video Review.',
         purchaseAction: 'Buy Now for $180/year',
         purchaseActionSale: 'Buy Now for $153/year',
         saleBannerSale: 'TechSmith Summer Sale!',
         saleBannerSale2: 'Get 15% Off Now!',
         salePrice: '$153/year USD',
         salesPriceDisclaimer: '(Discount applies to first year only)'
      },
      pricing: {
         list: [
            noLimitsValueProp,
            freeSupportValueProp,
            noCreditCardNecessary
         ]
      },
      groupsMenu: {
         oneMember: '{param0} Member',
         members: '{param0} Members'
      },
      preferences: {
         features: {
            heading: 'Experimental Features',
            text1: 'These features are still being researched by the team.',
            text2: ' They may change or be removed at any time.',
            text3: ' Try them out, and let us know what you think by ',
            text4: 'taking this survey.',
            surveyTitle: 'Give features feedback'
         },
         notification: {
            heading: 'Email Preferences',
            commentAlerts: 'Comment Alerts',
            replyAlerts: 'Reply Alerts',
            commentExplanation: 'Send an email when a new comment is posted on a review you own',
            replyExplanation: 'Send an email when someone replies to a comment or reply you made'
         },
         preferencesMenuTitle: 'Preferences'
      },
      manageReviewers: {
         rejected: '{param0} invalid email{param1} found',
         added: '{param0} reviewer{param1} ready to be added'
      },
      manageReviewersList: {
         emptyState: 'No Reviewers Added',
         pendingLabel: 'Will be added',
         addedLabel: 'Added',
         removingLabel: 'Will be removed',
         failedLabel: 'Failed to add'
      },
      manageReviewersModal: {
         cancel: 'Cancel',
         save: 'Save',
         done: 'Done',
         message: 'Your invitations have been sent',
         bannerTextOwner: 'Manage Reviewers',
         bannerTextReviewer: 'Reviewers',
         buttonText: 'Continue',
         alertTitle: 'Unsaved Changes',
         alertClose: 'Cancel',
         alertConfirm: 'Discard',
         alertText: 'You have unsaved changes to your reviewers. Are you sure you want to discard the changes?',
         saveAndNotify: 'Save and Notify'
      },
      editReviewModal: {
         bannerText: 'Edit Details',
         title: {
            title: 'Title',
            inputPlaceHolder: 'Name your review (required)'
         },
         description: {
            title: 'Description for Version {param0}',
            inputPlaceholder: 'Additional information about your {param0}'
         }
      },
      startReviewModal: {
         bannerText: 'New Review',
         reviewDetails: {
            title: {
               title: 'Title',
               reviewTitle: 'Review title:',
               inputPlaceHolder: 'Name your review (required)'
            },
            deadline: {
               title: 'Deadline',
               removeTitle: 'Remove deadline',
               inputPlaceholder: 'Set deadline'
            },
            description: {
               title: 'Description',
               inputPlaceholder: 'Additional information about your {param0}'
            },
            mediaTypes: {
               video: 'video',
               image: 'image'
            }
         }
      },
      reviewerGroupsModal: {
         unsavedChanges: 'Unsaved Changes',
         cancel: 'Cancel',
         discard: 'Discard',
         alertText: 'You have unsaved changes to this group. Are you sure you want to discard the changes?'
      },
      selfIdentify: {
         badgeText: 'Enter a Display Name',
         tos: 'By continuing, you agree to our',
         tosLink: 'Terms of Service',
         placeholder: 'Temporary display name',
         buttonLabel: 'Submit',
         signin: 'or sign in with your',
         signinLink: 'TechSmith Account'
      },
      shareReviewLink: {
         title: 'Link',
         copy: 'Copy',
         copied: 'Copied',
         sendLink: 'Send Link'
      },
      shareReviewPrivacy: {
         title: 'Who has access',
         linkLabel: 'Anyone with the link',
         reviewersLabel: 'Only added reviewers (requires TechSmith account)'
      },
      shareReviewModal: {
         headerTitle: 'Share Review',
         createdLink: 'Review Created',
         manageReviewers: 'Manage Reviewers',
         reviewers: 'Reviewers',
         oneReviewerAdded: '1 reviewer added',
         multipleReviewersAdded: '{param0} reviewers added',
         noReviewersAdded: 'No reviewers added',
         done: 'Done',
         toast: 'Settings saved'
      },
      versions: {
         versionFull: 'Version {param0}',
         versionShortDropDown: 'V {param0}',
         versionFullDropDown: 'Version {param0}',
         versionsMenuTitle: 'Versions',
         addVersionButtonText: 'Add New Version',
         goToLatestButtonText: 'View Latest',
         goToLatestVerboseButtonText: 'View Latest Version',
         newVersionUploadModalText: 'Upload New Version',
         newVersionDetailsModalText: 'Add Details for Version {param0}',
         createVersion: 'Create Version',
         createVersionWithReviewers: 'Create and Notify',
         viewOnlyHeader: 'View Only Mode',
         viewOnlyBodyText1: 'There is a newer version of this review available. ',
         viewOnlyBodyLinkText: 'View the latest version',
         viewOnlyBodyText2: ' to add comments.',
         versionModalMessageSingular: '1 reviewer will be notified of the new version',
         versionModalMessagePlural: '{param0} reviewers will be notified of the new version',
         deleteVersion: 'Delete Version',
         confirmVersionDeletionText: 'This will permanently delete the version and any comments associated with it.',
         versionNotFound: 'Sorry, we can\'t find that version of the review. It may have been deleted.',
         versionNotFoundHeader: 'Version Not Found'
      },
      mediaInfo: {
         fileName: 'FILENAME',
         type: 'TYPE',
         size: 'SIZE',
         dimensions: 'DIMENSIONS',
         duration: 'DURATION'
      }
   },
   tabs: {
      dashboard: {
         all: 'All Reviews',
         owned: 'My Reviews',
         others: 'Shared with Me'
      },
      review: {
         comments: '{param0} Comments',
         comment: '1 Comment',
         details: 'Details'
      }
   },
   emptyStates: {
      dashboard: {
         allAndOwnedTitle: 'Start a Review',
         startReviewMessage: 'Your dashboard is empty. Upload a new video to start a new review.',
         trialExpiredMessage: 'Your trial has expired. Purchase a subscription to start a new review.',
         noSharedTitle: 'No Shared Reviews',
         noSharedMessage: 'Your dashboard is empty.  You do not have any reviews shared with you.'
      },
      comments: {
         noComments: 'No Comments',
         noMatchingComments: 'No results match your search',
         clearSearchButton: 'Clear Search',
         noUnresolvedComments: 'No Unresolved Comments',
         showAllCommentsButton: 'Show All Comments'
      }
   },
   termsOfService: {
      title: 'TechSmith Video Review Service',
      subTitle: 'Terms of Service',
      description: 'Take a moment to review our terms',
      prompt: 'Take a moment to review our terms. They must be accepted to continue to use the Service.',
      button: {
         print: 'Print',
         accept: 'Accept and Continue'
      }
   },
   statusIndicator: {
      menu: 'You\'re using {param0} of your {param1} available reviews',
      description: 'Using {param0} of your {param1} reviews'
   },
   csvExport: {
      headers: {
         reviewTitle: 'Review Title',
         commenter: 'Commenter',
         comment: 'Comment',
         likes: 'Likes',
         reply: 'Reply',
         dateAndTime: 'Date and Time',
         resolved: 'Resolved',
         timecode: 'Timecode',
         annotation: 'Annotation',
         commentId: 'Comment ID'
      },
      hasValueText: 'yes',
      noValueText: 'no'
   },
   titles: {
      uploadMedia: 'Upload Media',
      addDetails: 'Add Details',
      shareReview: 'Share Review',
      editReviewDescription: 'Edit Description for Version {param0}',
      editReviewTitle: 'Edit Title'
   },
   notifications: {
      loadMore: 'Load More',
      activity: 'Activity',
      markAsRead: 'Mark as read',
      markAllAsRead: 'Mark All as Read',
      onlyShowUnread: 'Show All',
      pretext: 'Show: ',
      all: {
         activity: 'All Activity',
         label: 'All Activity',
         title: 'Showing All Activity',
         emptyText: 'No Notifications'
      },
      unread: {
         activity: 'Unread Activity',
         label: 'Unread Activity',
         title: 'Showing Unread Activity',
         emptyText: 'No New Notifications'
      },
      content: {
         deadlineApproaching: {
            header: ' has a review approaching the deadline ',
            body: 'The deadline for reviewing {param0} is approaching. Deadline date - {param1}'
         },
         newComment: {
            header: ' added a comment to '
         },
         newCommentReply: {
            header: ' replied to your comment on '
         },
         newReviewConfirmation: {
            header: 'You have successfully created a new review ',
            body: 'You have successfully created a new review: {param0}.' // value was ported from notification service, but unused in code?
         },
         newReviewInvitation: {
            header: ' invited you to review ',
            body: 'You have been invited to review: {param0}.'
         },
         newReviewVersionConfirmation: {
            header: 'You have successfully created new version for review ',
            body: 'You have successfully created: {param0} - Version {param1}.' // value was ported from notification service, but unused in code?
         },
         newReviewVersionInvitation: {
            header: ' invited you to review a new version of ',
            body: 'You have been invited to review: {param0} - Version {param1}.'
         },
         reviewByDateModification: {
            header: ' changed the deadline on ',
            body: 'The deadline for reviewing {param0} has been changed to - {param1}.'
         },
         startTrial: {
            header: 'You have successfully started your trial'
         },
         userActivation: {
            header: 'Your account has been successfully activated'
         }
      }
   },
   accessibility: {
      versionInfoRowRadialButtonLabel: 'Version {param0} radial button',
      versionInfoRowThumbnailAltText: 'Version {param0} thumbnail',
      reviewBypassBlockText: 'Skip to content',
      playVideoHiddenButtonText: 'Play Video',
      mobileAddCommentIconLabel: 'Add comment',
      comments: {
         resolveCommentAriaLabel: 'Resolve Comment',
         anotationsAriaLabel: 'Toggle comment annotations',
         parentCommentAriaLabel: '{user} at {time} comments {commentText} {annotationStatus}',
         annotationAttached: 'Annotation attached',
         replyAriaLabel: '{user} replies {commentText}',
         commentMarkAriaLabel: 'At {time}, {user} comments {commentText}',
         likeCommentButtonAriaLabel: 'Like Comment',
         likeCountAriaLabelSingular: ', 1 like.',
         likeCountAriaLabelPlural: ', {number} likes.',
         commentSubmittedAriaLiveText: 'Comment submitted.',
         commentTimeButtonAriaLiveText: 'Video progress set to {time}'
      },
      annotationToolbar: {
         squareButtonAriaLabel: 'Square annotation',
         arrowButtonAriaLabel: 'Arrow annotation',
         freehandButtonAriaLabel: 'Freehand annotation',
         colorSelectionAriaLabel: 'Select color. Currently selected: {color}',
         colors: {
            white: 'white',
            blue: 'blue',
            green: 'green',
            red: 'red',
            yellow: 'yellow'
         }
      }
   }
});
